import React, { lazy, Suspense } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Home from "./Home";
import Layout from "../Components/Layout";
import PlaygroundLayout from "../Components/PlaygroundLayout";

const About = lazy(() => import("./About"));
const Projects = lazy(() => import("./Projects"));
const NoPage = lazy(() => import("./404"));
const ResumeComponent = lazy(() => import("./Resume"));
const Food = lazy(() => import("./Playground/Food"));
const Playground = lazy(() => import("./Playground"));
const Music = lazy(() => import("./Playground/Music"));
const Tft = lazy(() => import("./Playground/Tft"));
const Bookbar = lazy(() => import("./Playground/Bookbar"));
const Strava = lazy(() => import("./Playground/Strava"));
const Poke = lazy(() => import("./Playground/Poke"));
const Patchnotes = lazy(() => import("./Patchnotes"));
const Patch = lazy(() => import("./Patch"));

const LoadingSpinner: React.FC = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "50vh",
      fontSize: "1.2rem",
      color: "#666",
    }}
  >
    Loading...
  </div>
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/resume",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <ResumeComponent />
      </Suspense>
    ),
  },
  {
    element: <Layout />,
    children: [
      {
        path: "/about",
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <About />
          </Suspense>
        ),
      },
      {
        path: "/projects",
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <Projects />
          </Suspense>
        ),
      },
      {
        path: "/patchnotes",
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <Patchnotes />
          </Suspense>
        ),
      },
      {
        path: "/patchnotes/:patchVersion",
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <Patch />
          </Suspense>
        ),
      },
      {
        path: "/playground",
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <Playground />
          </Suspense>
        ),
      },
    ],
  },
  {
    element: <PlaygroundLayout />,
    children: [
      {
        path: "/playground/food",
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <Food />
          </Suspense>
        ),
      },
      {
        path: "/playground/music",
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <Music />
          </Suspense>
        ),
      },
      {
        path: "/playground/Tft",
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <Tft />
          </Suspense>
        ),
      },
      {
        path: "/playground/bookbar",
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <Bookbar />
          </Suspense>
        ),
      },
      {
        path: "/playground/strava",
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <Strava />
          </Suspense>
        ),
      },
      {
        path: "/playground/poke",
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <Poke />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "*",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <NoPage />
      </Suspense>
    ),
  },
]);

const App: React.FC = () => {
  React.useEffect(() => {
    const prefetchRoutes = () => {
      import("./About");
      import("./Projects");
    };

    const timeoutId = window.setTimeout(prefetchRoutes, 2000);
    return () => window.clearTimeout(timeoutId);
  }, []);

  return <RouterProvider router={router} />;
};

export default App;

